import scrollToElement from 'scroll-to-element'
import { mq } from 'utilities/breakpoints'

export default function ScrollTo(anchor) {
    const mediaBreakpoint = window.matchMedia(mq['SM_MAX'])
    const targetElementName = anchor.hash.substr(1)
    const targetElement = document.querySelector(
        `[data-anchor="${targetElementName}"]`
    )

    anchor.addEventListener('click', scrollTo)

    function scrollTo() {
        if (mediaBreakpoint.matches) {
            scrollToElement(targetElement, {
                ease: 'in-out-quart',
                duration: 1000,
            })
        }
    }
}
